import React from "react";
import { Link } from "gatsby";
import Container from "./container";
import { cn } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";
import PortableText from "./portableText";
import Icon from "./icon";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";

import * as styles from "../styles/components/fc-multi-column-content.module.css";

const MultiColumnContent = (props) => {
  const {
    _key,
    title,
    content,
    themeColorBg,
    centerAligned,
    alternativeLayout,
    slider,
  } = props;

  if (slider) {
    function reorderArray(arr) {
      // Find the object with primaryTestimonial set to true
      const primaryIndex = arr.findIndex(
        (item) => item.primaryTestimonial === true
      );

      // If no primaryTestimonial is found, return the array as is
      if (primaryIndex === -1) {
        return arr;
      }

      // Remove the object from the array
      const [primaryItem] = arr.splice(primaryIndex, 1);

      // Determine if the device is mobile based on screen width (e.g., < 768px for mobile)
      const hasWindow = typeof window !== "undefined";
      const isMobile = hasWindow && window.innerWidth <= 768;

      // Insert the object at index 0 for mobile, or index 1 for other devices
      const targetIndex = isMobile ? 0 : 1;
      arr.splice(targetIndex, 0, primaryItem);

      return arr;
    }
    return (
      <div
        className={cn(
          styles.root,
          themeColorBg && styles.bg,
          themeColorBg && "color-palette-bg",
          "color-palette-border-light",
          centerAligned && styles.center
        )}
        key={_key}
      >
        <Container>
          {title && (
            <h2 className={cn(styles.title, "color-palette-color")}>{title}</h2>
          )}

          {content && content.length > 0 && (
            <div className={styles.swiperGrid}>
              <Swiper
                sliderPerView={3}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                  },
                  640: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 3,
                  },
                }}
                effect="fade"
                loop={true}
                modules={[Navigation, Autoplay]}
                navigation={{
                  nextEl: ".swiper-next",
                  prevEl: ".swiper-prev",
                }}
                spaceBetween={50}
              >
                {reorderArray(content).map((col) => {
                  return (
                    <SwiperSlide className={cn(styles.item)} key={col._key}>
                      <div
                        className={
                          !alternativeLayout ? styles.contentWrap : undefined
                        }
                      >
                        {col.icon && col.icon.asset && (
                          <div className={styles.icon}>
                            <img
                              src={imageUrlFor(buildImageObj(col.icon))
                                .auto("format")
                                .url()}
                              alt=""
                            />
                          </div>
                        )}
                        {col.title && (
                          <h3 className={cn("h5", styles.colTitle)}>
                            {col.title}
                          </h3>
                        )}
                        {col._rawContent && (
                          <div className="entry-content">
                            <PortableText blocks={col._rawContent} isForTestimonial />
                          </div>
                        )}
                        {col.link && col.link.url && (
                          <>
                            {col.link.blank ? (
                              <a
                                href={col.link.url}
                                className={cn(
                                  "link color-palette-color-underline color-palette-svg-stroke",
                                  styles.link
                                )}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {col.link.text}
                                <Icon symbol="arrow-right" />
                              </a>
                            ) : (
                              <Link
                                to={col.link.url}
                                className={cn(
                                  "link color-palette-color-underline color-palette-svg-stroke",
                                  styles.link
                                )}
                              >
                                {col.link.text}
                                <Icon symbol="arrow-right" />
                              </Link>
                            )}
                          </>
                        )}
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              <div className={styles.swiperNavigation}>
                <div
                  
                  className={cn(
                    styles.swiperPrev,
                    "swiper-prev",
                    "color-palette-bg",
                  )}
                >
                  <Icon symbol="arrow-carousal" />
                </div>
                <div
                  className={cn(
                    styles.swiperNext,
                    "swiper-next",
                    "color-palette-bg",
                   
                  )}
                >
                  <Icon symbol="arrow-carousal" />
                </div>
              </div>
            </div>
          )}
        </Container>
      </div>
    );
  }
  return (
    <div
      className={cn(
        styles.root,
        themeColorBg && styles.bg,
        themeColorBg && "color-palette-bg",
        "color-palette-border-light",
        centerAligned && styles.center
      )}
      key={_key}
    >
      <Container>
        {title && (
          <h2 className={cn(styles.title, "color-palette-color")}>{title}</h2>
        )}
        {content && content.length > 0 && (
          <div className="grid">
            {content.map((col) => {
              return (
                <div
                  className={cn(
                    alternativeLayout
                      ? "col-12 col-sm-6 col-lg-4"
                      : "col-12 col-lg-4",
                    styles.item
                  )}
                  key={col._key}
                >
                  <div
                    className={
                      !alternativeLayout ? styles.contentWrap : undefined
                    }
                  >
                    {col.icon && col.icon.asset && (
                      <div className={styles.icon}>
                        <img
                          src={imageUrlFor(buildImageObj(col.icon))
                            .auto("format")
                            .url()}
                          alt=""
                        />
                      </div>
                    )}
                    {col.title && (
                      <h3 className={cn("h5", styles.colTitle)}>{col.title}</h3>
                    )}
                    {col._rawContent && (
                      <div className="entry-content">
                        <PortableText blocks={col._rawContent} />
                      </div>
                    )}
                    {col.link && col.link.url && (
                      <>
                        {col.link.blank ? (
                          <a
                            href={col.link.url}
                            className={cn(
                              "link color-palette-color-underline color-palette-svg-stroke",
                              styles.link
                            )}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {col.link.text}
                            <Icon symbol="arrow-right" />
                          </a>
                        ) : (
                          <Link
                            to={col.link.url}
                            className={cn(
                              "link color-palette-color-underline color-palette-svg-stroke",
                              styles.link
                            )}
                          >
                            {col.link.text}
                            <Icon symbol="arrow-right" />
                          </Link>
                        )}
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Container>
    </div>
  );
};

export default MultiColumnContent;
